module.exports = {
  apiHost: "https://api.almouj.sensoreal.app",
  assetsHost: "https://assets.almouj.sensoreal.app",

  header: {
    text: {
      en: "Your Favourite Selections",
      ar: "Your Favourite Selections",
    },
    logo: "https://assets.almouj.sensoreal.app/misc/almouj-logo.png",
    color: "#fff",
  },
  langs: [
    { code: "en", dir: "ltr" },
    { code: "ar", dir: "rtl" },
  ],
  currency: {
    locale: "en-AU",
    code: "OMR",
  },
  style: {
    primaryColor: "#131836",
    textColor: "#fff",
  },
  contact: {
    website: "https://almouj.com",
    address: "The Walk Mall Street No. 6, Muscat 138, Oman",
    phone: "+968 2453 4444",
    email: "",
  },
  links: {
    privacy: "",
    youtube: "",
    linkedin: "",
    twitter: "",
    instagram: "",
    facebook: "https://www.facebook.com/almouj.muscat/",
  },
};
